/* eslint-disable react/no-unused-prop-types */
import { string } from 'prop-types';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import OptionFilter from '../option-filter/OptionFilter';
import getOptionFilterStateServiceFactory from '../option-filter/OptionFilterStateService';

export const filterId = 'ServerType';
export const filterTitle = t`Server Type`;
export const options = [
    {
        name: t`Server`,
        value: 'server',
    },
    {
        name: t`Hypervisor`,
        value: 'hypervisor',
    },
    {
        name: t`Virtual Machine`,
        value: 'virtualmachine',
    },
];

function ServerTypeFilter({ state, filterActions }) {
    return <OptionFilter options={options} state={state} filterActions={filterActions} />;
}

ServerTypeFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: string,
};

ServerTypeFilter.defaultProps = {
    ...OptionFilter.defaultProps,
    id: filterId,
    title: filterTitle,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getOptionFilterStateServiceFactory(filterTitle, options, 'subType'),
})(ServerTypeFilter);
